import { useAuthStore } from '../data/useAuthStore'
import { pb } from './Pocketbase'
import { updateUserAfterOAuth } from '../api/users'
import { AuthFetchStatus } from '../types'

export const useAuth = () => {
  const { refetchUser, reset } = useAuthStore()

  const loginViaGoogle = async () => {
    const authData = await pb
      .collection('users')
      .authWithOAuth2({ provider: 'google' })

    const userId = pb.authStore.record?.id
    const name = authData.meta?.name ?? ''
    if (userId != null) {
      await updateUserAfterOAuth(userId, name)
      const status = await refetchUser()

      if (status === AuthFetchStatus.Deleted) {
        throw new Error('Your account has been scheduled for deletion and is no longer accessible.')
      } else if (status === AuthFetchStatus.Unauthorized) {
        throw new Error('Your account could not be verified. Please try logging in again.')
      } else if (status === AuthFetchStatus.Error) {
        throw new Error('An error occurred while fetching your account information. Please try again.')
      }
    }
  }

  const loginViaApple = async () => {
    const authData = await pb
      .collection('users')
      .authWithOAuth2({ provider: 'apple' })

    const userId = pb.authStore.record?.id
    const name = authData.meta?.name ?? ''
    if (userId != null) {
      await updateUserAfterOAuth(userId, name)
      const status = await refetchUser()

      if (status === AuthFetchStatus.Deleted) {
        throw new Error('Your account has been scheduled for deletion and is no longer accessible.')
      } else if (status === AuthFetchStatus.Unauthorized) {
        throw new Error('Your account could not be verified. Please try logging in again.')
      } else if (status === AuthFetchStatus.Error) {
        throw new Error('An error occurred while fetching your account information. Please try again.')
      }
    }
  }

  const isLoggedIn = (): boolean => {
    return pb.authStore.isValid
  }

  const logout = () => {
    pb.authStore.clear()
    reset()
  }

  return { isLoggedIn, loginViaGoogle, loginViaApple, logout }
}
